import moment from "moment";
import { useCallback } from "react";
import React, { createContext, useContext } from "react";
import { useFirebase } from "../useFirebase";
import useNotifications from "../useNotifications";

const status = 'unread';

export const NotificationsContext = createContext({
  loading: false,
  _notifications: [],
  _fetch: [],
  total: 0,
  clearAll: () => { },
  removeNotification: () => { },
});

export const NotificationsProvider = ({ children }) => {
  const {
    loading,
    _notifications,
    _fetch,
    total,
    addNotification,
    clearAll,
    removeNotification,
  } = useNotifications({ status });

  const value = {
    loading,
    _notifications,
    _fetch,
    total,
    clearAll,
    removeNotification,
  };

  const onMessage = useCallback((notification) => {
    let data = {};

    try {
      data = JSON.parse(notification.data?.data);
    } catch (err) {
    }

    addNotification({
      id: notification.messageId,
      type: notification.data?.type,
      title: notification.notification?.title,
      body: notification.notification?.body,
      createdAt: moment().toString(),
      data: data,
      read: false,
    });

  }, []);

  useFirebase(onMessage);

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  )
};

export const useNotificationsContext = () => {
  const value = useContext(NotificationsContext);
  return value;
}
